"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useClient_1 = __importDefault(require("./useClient"));
const subscriptionQueryCache_1 = require("./subscriptionQueryCache");
function useSubscriptionBase(options) {
    const client = useClient_1.default(options.clientName);
    react_1.useEffect(() => {
        if (options.skip === true)
            return;
        const subscription = client.subscribe(options).subscribe({
            next: (params) => {
                if (options.onData) {
                    options.onData(params.data, params);
                }
            },
            error: (error) => {
                if (options.onError) {
                    options.onError(error);
                }
                else {
                    console.error('Error in subscription', error);
                }
            },
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [subscriptionQueryCache_1.getCacheKey(options)]);
}
exports.default = useSubscriptionBase;
